import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Leistungen from "./pages/Leistungen";
import UeberUns from "./pages/UeberUns";
import Kontakt from "./pages/Kontakt";
import Datenschutz from "./pages/Datenschutz";
import Impressum from "./pages/Impressum";
import Ratgeber from "./pages/Ratgeber";
import ArtikelDetail from "./pages/ArtikelDetail";
import InternesAudit from "./pages/InternesAudit";
import HandbuchSoftware from "./pages/HandbuchSoftware";
import ExternerQMBeauftragter from "./pages/ExternerQMBeauftragter";
import BildungstraegerGruenden from "./pages/BildungstraegerGruenden";
import Musterunterlagen from "./pages/Musterunterlagen";

// ScrollToTop component to reset scroll position on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/leistungen" element={<Leistungen />} />
        <Route path="/ueber-uns" element={<UeberUns />} />
        <Route path="/kontakt" element={<Kontakt />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/ratgeber" element={<Ratgeber />} />
        <Route path="/ratgeber/:slug" element={<ArtikelDetail />} />
        <Route path="/internes-audit" element={<InternesAudit />} />
        <Route path="/handbuch-software" element={<HandbuchSoftware />} />
        <Route path="/externer-qm-beauftragter" element={<ExternerQMBeauftragter />} />
        <Route path="/bildungstraeger-gruenden" element={<BildungstraegerGruenden />} />
        <Route path="/musterunterlagen" element={<Musterunterlagen />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
